export default function redirectToAuth() {
  const { location, localStorage } = window;
  const { pathname, search } = location;
  localStorage.setItem('redirectedFrom', `${pathname}${search}`);
  location.href = '/auth';
}